import APIClient from './index';

export const submitBonus = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/Admin/submit_bonus`, data)
      .then(response => resolve(response.data))
      .catch(error => reject(error?.data?.error));
  });
};
